var stackerNav = {
	el: null, // needs to be set on init with elSelector
	elSelector: '.stacker-nav',
	scroll_duration: 600,
	offset:0, // navbar height
    updateActive: function(e) {

    	// if in scroll event, "this" is given as param
    	var _this = e == null ? this : e.data.obj;

    	// nav height with or without top menu
		// var fixed_nav_height = 0;
		//var fixed_nav_height = nav_height;
		var fixed_nav_height = $('#navbar .bottom-inner').height();

		if ( $('#navbar').hasClass('is-maximized') ) {
			fixed_nav_height += $('#navbar .top-inner').height();
		}

		/* Active Section */
		_this.anchors.each(function(){
			$this = $(this);
			var sectionIndex = _this.el.find('a[href="#'+$this.attr('id')+'"]').data('number');

			// var this_id = $this.attr('id');
			var this_id = $this.attr('id').replace('child-','');
				
			var section = $('#section-' + this_id);

			if ( this_id === 'overview' ) {
				section = $('#section-0');
			}

			// section top is at the top of the window, or above
			// var isInOrAbove = Math.floor($this.offset().top  - fixed_nav_height) <= $(window).scrollTop();
			var isInOrAbove = Math.floor($this.offset().top ) <= $(window).scrollTop();
			// section bottom is in the window, or underneath
			// var isInOrUnder = Math.floor($this.offset().top + section.outerHeight() - fixed_nav_height ) > $(window).scrollTop();
			// var isInOrUnder = Math.floor($this.offset().top + section.outerHeight() ) > $(window).scrollTop();
			var isInOrUnder = Math.floor($this.offset().top + section.outerHeight() ) - 1 > $(window).scrollTop(); // -1 to make sure 2 items aren't active at the same time...
			if ( this_id === 'overview' ) {
				// fixed_nav_height is for general stacker-offset css top (- 72px)
				// 10 is for overview stacker offset (10px)
				var isInOrUnder = Math.floor($this.offset().top + section.outerHeight() - fixed_nav_height - 10) > $(window).scrollTop();
			}
			// var isInOrUnder = Math.floor($this.offset().top + section.height() - fixed_nav_height ) > $(window).scrollTop();
			// is in window
			var isActive =  isInOrAbove && isInOrUnder;
			
			if ( this_id === 'overview' && isInOrUnder ) {
				_this.nav_items.eq(sectionIndex).addClass('active');
				return;
			}

			// if first section is in window or above: active
			if ( isActive ) {
				_this.nav_items.eq(sectionIndex).addClass('active');
			}else {
				_this.nav_items.eq(sectionIndex).removeClass('active');
			}

		});
    },
    scrollToSection: function(e) {
		e.preventDefault();

    	var _this = e.data.obj;
		// hide navbar top section
		navbar.minimize();

		// smooth scroll
		$('body').addClass('scrolling-to-section');
		_this.smoothScroll($(this.hash), $(this).data('number'));
    },
    smoothScroll: function(target, index) {
    	var _this = this;
		var hash = $(target).attr('id');

		// scroll to anchor which is positionned via css up 72 px (navbar height)

		var top = target.offset().top;
		if ( hash == 'overview' && $('#navbar').hasClass('fixed') ) {
			var top = 0;
		} 
		// else if ( hash == 'overview' ) {
		// 	top += 10; // fix navbar
		// }

		$('body,html').stop().animate({
			'scrollTop': top
		}, _this.scroll_duration, function () {
			// update url in animate callback
			if ( top > 0 ) {
				window.location.hash = hash;
			}
		});

		setTimeout(function(){
			$('body').removeClass('scrolling-to-section');
		}, _this.scroll_duration+50 );
    },
	init: function() {
		var _this = this;

		var stackerNav = $(_this.elSelector);

		if ( !stackerNav.length) return;

		_this.el = $(_this.elSelector);
		_this.nav_items = _this.el.find('a');
		//_this.nav_height = nav.parents('.stacker-nav-container').parents('.menu_inner').outerHeight(true); // height of helper bar, padding, margin, border included
		_this.anchors = $('.has-stacker-nav .anchor');

		// === Active section
		_this.updateActive();
		$(window).on('scroll', {obj: _this},  _this.updateActive ); // passing _this to method

		// === Smooth Scroll to the stacker section
	    _this.nav_items.on('click', {obj: _this}, _this.scrollToSection); // passing _this to method
	},
	destroy: function() {
		var _this = this;

		if ( !stackerNav.length) return;

		$(window).off('scroll', _this.updateActive );
		_this.nav_items.off('scroll', _this.scrollToSection ); // SCROLL TO SECTION METHOD
	}
}